import React from 'react'

const OPERATORS = {
  must: 'Require',
  should: 'Include',
  must_not: 'Exclude'
}

const NEXT_OPERATOR = {
  must: 'should',
  should: 'must_not',
  must_not: 'must'
}

export default function OperatorButton ({ value, onChange, className }) {
  const onClick = () => {
    onChange(NEXT_OPERATOR[value])
  }
  return (
    <button type='button' onClick={onClick} className={className}>
      {OPERATORS[value]}
    </button>
  )
}



// WEBPACK FOOTER //
// ./src/components/search/OperatorButton.js